/* Diabec shared cookie consent banner — GDPR/ePrivacy/PECR/CCPA/GPC compliant.
   Include on every page with: <script src="diabec-cookie-banner.js" defer></script>
   Reads / writes these localStorage keys:
     diabec_cookie_consent       : 'all' | 'essential' | 'custom'
     diabec_cookie_consent_date  : ISO timestamp
     diabec_consent_analytics    : 'true' | 'false'
     diabec_consent_marketing    : 'true' | 'false'
     diabec_gpc_honored          : 'true' (if Global Privacy Control signal respected)
*/
(function(){
    if (window.__diabecCookieBannerInit) return;
    window.__diabecCookieBannerInit = true;

    function inject() {
        if (document.getElementById('cookieConsent')) return; // page already has one

        var wrap = document.createElement('div');
        wrap.id = 'cookieConsent';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'false');
        wrap.setAttribute('aria-labelledby', 'cookieConsentTitle');
        wrap.setAttribute('aria-describedby', 'cookieConsentDesc');
        wrap.style.cssText = 'display:none; position:fixed; bottom:0; left:0; right:0; z-index:9999; background:rgba(44,62,31,0.97); backdrop-filter:blur(12px); padding:1.2rem 2rem; box-shadow:0 -4px 20px rgba(0,0,0,0.2); font-family:\'Inter\',-apple-system,BlinkMacSystemFont,sans-serif;';
        wrap.innerHTML = ''
            + '<div style="max-width:1100px; margin:0 auto;">'
            +   '<div id="cookieConsentMain" style="display:flex; align-items:center; justify-content:space-between; gap:1.5rem; flex-wrap:wrap;">'
            +     '<div style="flex:1; min-width:280px;">'
            +       '<h2 id="cookieConsentTitle" style="color:#fff; font-size:0.95rem; margin:0 0 0.3rem; font-weight:700;">Your cookie choices</h2>'
            +       '<p id="cookieConsentDesc" style="color:rgba(255,255,255,0.9); font-size:0.88rem; margin:0; line-height:1.6;">We use cookies to improve your experience. Essential cookies are always active. You can accept all cookies, reject optional cookies, or manage your preferences. <a href="diabec-cookie-policy.html" style="color:#c8a96e; text-decoration:underline;">Cookie Policy</a></p>'
            +     '</div>'
            +     '<div style="display:flex; gap:0.6rem; flex-shrink:0; flex-wrap:wrap;">'
            +       '<button type="button" data-consent="all" style="background:linear-gradient(135deg,#c8a96e,#b8954e); color:#2c3e1f; border:none; padding:0.55rem 1.4rem; border-radius:8px; font-weight:700; font-size:0.82rem; cursor:pointer; letter-spacing:0.03em; text-transform:uppercase; min-height:44px;">Accept All</button>'
            +       '<button type="button" data-consent="essential" style="background:linear-gradient(135deg,#c8a96e,#b8954e); color:#2c3e1f; border:none; padding:0.55rem 1.4rem; border-radius:8px; font-weight:700; font-size:0.82rem; cursor:pointer; letter-spacing:0.03em; text-transform:uppercase; min-height:44px;">Reject All</button>'
            +       '<button type="button" data-consent="manage" style="background:transparent; color:rgba(255,255,255,0.9); border:1px solid rgba(255,255,255,0.3); padding:0.55rem 1.4rem; border-radius:8px; font-weight:600; font-size:0.82rem; cursor:pointer; letter-spacing:0.03em; min-height:44px;">Manage Preferences</button>'
            +     '</div>'
            +   '</div>'
            +   '<div id="cookieConsentPrefs" style="display:none;">'
            +     '<p style="color:rgba(255,255,255,0.9); font-size:0.88rem; margin:0 0 1rem; line-height:1.6;"><strong>Manage Cookie Preferences</strong></p>'
            +     '<label style="display:flex; align-items:flex-start; gap:0.6rem; color:rgba(255,255,255,0.85); font-size:0.82rem; margin-bottom:0.6rem; line-height:1.5;"><input type="checkbox" checked disabled style="margin-top:0.2rem;"><span><strong>Essential Cookies</strong> (always active): Required for the website to function, including shopping cart and secure checkout.</span></label>'
            +     '<label style="display:flex; align-items:flex-start; gap:0.6rem; color:rgba(255,255,255,0.85); font-size:0.82rem; margin-bottom:0.6rem; line-height:1.5;"><input type="checkbox" id="consentAnalytics" style="margin-top:0.2rem;"><span><strong>Analytics Cookies</strong>: Google Analytics to understand how visitors use our website. Data is anonymised.</span></label>'
            +     '<label style="display:flex; align-items:flex-start; gap:0.6rem; color:rgba(255,255,255,0.85); font-size:0.82rem; margin-bottom:1rem; line-height:1.5;"><input type="checkbox" id="consentMarketing" style="margin-top:0.2rem;"><span><strong>Marketing Cookies</strong>: Used to deliver relevant advertisements and measure campaign effectiveness.</span></label>'
            +     '<div style="display:flex; gap:0.6rem; flex-wrap:wrap;">'
            +       '<button type="button" data-consent="save" style="background:linear-gradient(135deg,#c8a96e,#b8954e); color:#2c3e1f; border:none; padding:0.55rem 1.4rem; border-radius:8px; font-weight:700; font-size:0.82rem; cursor:pointer; letter-spacing:0.03em; text-transform:uppercase; min-height:44px;">Save Preferences</button>'
            +       '<button type="button" data-consent="back" style="background:transparent; color:rgba(255,255,255,0.9); border:1px solid rgba(255,255,255,0.3); padding:0.55rem 1.4rem; border-radius:8px; font-weight:600; font-size:0.82rem; cursor:pointer; min-height:44px;">Back</button>'
            +     '</div>'
            +   '</div>'
            + '</div>';
        document.body.appendChild(wrap);

        wrap.addEventListener('click', function(e){
            var t = e.target.closest('[data-consent]');
            if (!t) return;
            var action = t.getAttribute('data-consent');
            if (action === 'all' || action === 'essential') setConsent(action);
            else if (action === 'manage') { document.getElementById('cookieConsentMain').style.display = 'none'; document.getElementById('cookieConsentPrefs').style.display = 'block'; }
            else if (action === 'back') { document.getElementById('cookieConsentPrefs').style.display = 'none'; document.getElementById('cookieConsentMain').style.display = 'flex'; }
            else if (action === 'save') savePrefs();
        });
    }

    function pushConsent(analytics, marketing) {
        // Google Consent Mode v2 update
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                analytics_storage: analytics ? 'granted' : 'denied',
                ad_storage:        marketing ? 'granted' : 'denied',
                ad_user_data:      marketing ? 'granted' : 'denied',
                ad_personalization:marketing ? 'granted' : 'denied'
            });
        }
        // Custom event so any other tag (Meta pixel, TikTok, Klaviyo) can react
        try {
            window.dispatchEvent(new CustomEvent('diabec:consent', {
                detail: { analytics: analytics, marketing: marketing }
            }));
        } catch (e) { /* old browser */ }
    }

    function setConsent(level) {
        localStorage.setItem('diabec_cookie_consent', level);
        localStorage.setItem('diabec_cookie_consent_date', new Date().toISOString());
        var analytics = (level === 'all');
        var marketing = (level === 'all');
        localStorage.setItem('diabec_consent_analytics', analytics ? 'true' : 'false');
        localStorage.setItem('diabec_consent_marketing', marketing ? 'true' : 'false');
        pushConsent(analytics, marketing);
        var el = document.getElementById('cookieConsent');
        if (el) el.style.display = 'none';
    }

    function savePrefs() {
        var analytics = document.getElementById('consentAnalytics').checked;
        var marketing = document.getElementById('consentMarketing').checked;
        localStorage.setItem('diabec_consent_analytics', analytics ? 'true' : 'false');
        localStorage.setItem('diabec_consent_marketing', marketing ? 'true' : 'false');
        localStorage.setItem('diabec_cookie_consent', (analytics || marketing) ? 'custom' : 'essential');
        localStorage.setItem('diabec_cookie_consent_date', new Date().toISOString());
        pushConsent(analytics, marketing);
        document.getElementById('cookieConsent').style.display = 'none';
    }

    // expose globals for legacy inline onclicks on homepage (backwards compatible)
    window.setCookieConsent = setConsent;
    window.saveCookiePrefs = savePrefs;

    function init() {
        // Global Privacy Control (CO/CT/OR/MT state law compliance)
        if (navigator.globalPrivacyControl === true) {
            localStorage.setItem('diabec_cookie_consent', 'essential');
            localStorage.setItem('diabec_cookie_consent_date', new Date().toISOString());
            localStorage.setItem('diabec_gpc_honored', 'true');
            localStorage.setItem('diabec_consent_analytics', 'false');
            localStorage.setItem('diabec_consent_marketing', 'false');
            pushConsent(false, false);
            return;
        }
        // Replay stored consent on every page load so tags get the current state
        var consent = localStorage.getItem('diabec_cookie_consent');
        if (consent) {
            var a = localStorage.getItem('diabec_consent_analytics') === 'true';
            var m = localStorage.getItem('diabec_consent_marketing') === 'true';
            pushConsent(a, m);
            return;
        }
        inject();
        var el = document.getElementById('cookieConsent');
        if (el) {
            el.style.display = 'block';
            // Move focus into the dialog for keyboard / screen reader users
            var firstBtn = el.querySelector('button[data-consent]');
            if (firstBtn && typeof firstBtn.focus === 'function') {
                try { firstBtn.focus({ preventScroll: true }); } catch (e) { firstBtn.focus(); }
            }
            // Esc closes preferences pane and returns to main; on main, ignore.
            el.addEventListener('keydown', function (ev) {
                if (ev.key !== 'Escape' && ev.keyCode !== 27) return;
                var prefs = document.getElementById('cookieConsentPrefs');
                var main = document.getElementById('cookieConsentMain');
                if (prefs && prefs.style.display === 'block') {
                    prefs.style.display = 'none';
                    if (main) main.style.display = 'flex';
                    var firstMainBtn = main && main.querySelector('button[data-consent]');
                    if (firstMainBtn) firstMainBtn.focus();
                    ev.preventDefault();
                }
            });
        }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    // Public reopener: withdraw consent (ICO Apr 2026 - withdrawal must be as easy as giving)
    // Wire any element with class .reopen-cookie-banner or id #reopenCookieBanner, plus expose a global.
    function reopen(){
        try {
            localStorage.removeItem('diabec_cookie_consent');
            localStorage.removeItem('diabec_consent_analytics');
            localStorage.removeItem('diabec_consent_marketing');
            localStorage.removeItem('diabec_consent_ts');
        } catch(e) {}
        // Push denied state immediately so tags stop firing while the banner reopens
        pushConsent(false, false);
        var existing = document.getElementById('cookieConsent');
        if (existing) existing.parentNode.removeChild(existing);
        inject();
        var el = document.getElementById('cookieConsent');
        if (el) {
            el.style.display = 'block';
            var firstBtn = el.querySelector('button[data-consent]');
            if (firstBtn) { try { firstBtn.focus({ preventScroll: true }); } catch (e) { firstBtn.focus(); } }
        }
        return false;
    }
    window.diabecReopenCookieBanner = reopen;
    document.addEventListener('click', function(e){
        var t = e.target && (e.target.closest ? e.target.closest('.reopen-cookie-banner, #reopenCookieBanner') : null);
        if (t) { e.preventDefault(); reopen(); }
    });
})();
